import React from 'react';

const Home = () => {
	return(
		<>
			<div className="row">

			</div>
		</>
	)
}
export default Home;
